/** Relative time string from ISO timestamp. */
export function relativeTime(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime()
  const secs = Math.floor(ms / 1000)
  if (secs < 60) return 'just now'
  const mins = Math.floor(secs / 60)
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

/** Format ISO timestamp for display in timelines. */
export function formatTimestamp(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Tailwind border/text color class for a work order status. */
export function statusColor(status: string): string {
  switch (status) {
    case 'pending_approval': return 'text-amber-500 border-amber-500'
    case 'approved': return 'text-blue-500 border-blue-500'
    case 'in_progress': return 'text-swiss-green border-swiss-green'
    case 'completed': return 'text-swiss-gray-500 border-swiss-gray-300'
    case 'rejected': return 'text-swiss-red border-swiss-red'
    case 'failed': return 'text-swiss-red border-swiss-red'
    default: return 'text-swiss-gray-500 border-swiss-gray-300'
  }
}

/** Human-readable status label. */
export function statusLabel(status: string): string {
  switch (status) {
    case 'pending_approval': return 'Pending'
    case 'in_progress': return 'In Progress'
    default: return status.charAt(0).toUpperCase() + status.slice(1)
  }
}

/** Capitalize priority. */
export function priorityLabel(priority: string): string {
  return priority.charAt(0).toUpperCase() + priority.slice(1)
}
